import {Component, inject, OnInit, Signal} from '@angular/core';
import {AuthStore, authStore} from "../core/service/auth/auth.store";
import {RouterLink, RouterOutlet} from "@angular/router";
import {NgClass, NgTemplateOutlet} from "@angular/common";
import {TranslatePipe} from "@ngx-translate/core";

const adminTabs= [
    {title: 'PRODUCTS', link: 'products'},
    {title: 'USERS', link: 'users'},
    {title: 'QUOTATIONS', link: 'offers'},
]

@Component({
  selector: 'app-dashboard-page',
  imports: [
    RouterLink,
    RouterOutlet,
    NgTemplateOutlet,
    NgClass,
    TranslatePipe
  ],
  templateUrl: './dashboard-page.component.html',
  styleUrl: './dashboard-page.component.scss'
})
export class DashboardPageComponent implements OnInit {
  private authStore: AuthStore = inject(authStore);
  protected user: Signal<any> = this.authStore.loggedInUser;

  protected tabOpen: boolean = true;
  protected tabs: Array<any> = [ {title: 'PROJECTS', link: 'projects'}, ];


  ngOnInit() {
    if (this.authStore.hasAuthority('EMPLOYEE')()) {
      this.tabs.push(...adminTabs);
    }
  }

  toggleTab() {
    this.tabOpen = !this.tabOpen;
  }

}
